import { useEffect } from 'react'
import Script from 'next/script'

import { ConsentGroup } from 'constants/consent'
import useIsConsentGroupEnabled from 'hooks/useIsConsentGroupEnabled'

import { initDigitalMatter } from './utils'

const DigitalMatter = () => {
  const isTargetingConsentGroupEnabled = useIsConsentGroupEnabled(ConsentGroup.Targeting)

  useEffect(() => {
    initDigitalMatter(isTargetingConsentGroupEnabled)
  }, [isTargetingConsentGroupEnabled])

  if (!isTargetingConsentGroupEnabled) return null

  return (
    <Script
      id="digital-matter-script"
      data-testid="digital-matter-script"
      src="https://core.dimatter.ai/pubs/vinted-lt.min.js"
      strategy="lazyOnload"
    />
  )
}

export default DigitalMatter
